var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgEmergencyPass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 77,
    viewBox: "0 0 101 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 100,
    height: 62,
    rx: 4,
    fill: "#4B81AC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 96,
    height: 57,
    rx: 4,
    fill: "#D6E8F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 55,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#B0D2EC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 22,
    height: 3,
    rx: 1.5,
    fill: "#B0D2EC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 61,
    width: 28,
    height: 3,
    rx: 1.5,
    fill: "#B0D2EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 29.6596H45.5071V33.3519H38V29.6596Z",
    fill: "#E23E5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4932 29.6596H101V33.3519H93.4932V29.6596Z",
    fill: "#E23E5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.168 13.2282L90.3862 8.00999L93.0021 10.6259L87.7839 15.8441L85.168 13.2282Z",
    fill: "#E23E5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.229 15.8441L46.0107 10.6259L48.6267 8.00999L53.8449 13.2282L51.229 15.8441Z",
    fill: "#E23E5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6611 -0.00109863H71.3534V7.50604H67.6611V-0.00109863Z",
    fill: "#E23E5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8915 55.6278C50.8478 55.6278 49.1992 57.2764 49.1992 59.32V63.0123H89.8141V59.32C89.8141 57.2764 88.1655 55.6278 86.1218 55.6278H52.8915Z",
    fill: "#B12841"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8916 31.4988V51.922H86.1219V31.4988C86.1219 22.3431 78.6693 14.8905 69.5136 14.8905C60.3579 14.8905 52.8916 22.3431 52.8916 31.4988ZM67.6606 25.9672H71.3529V37.044H67.6606V25.9672ZM67.6606 40.7363H71.3529V44.4285H67.6606V40.7363Z",
    fill: "#E23E5C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEmergencyPass);
export default __webpack_public_path__ + "static/media/imgEmergencyPass.ae6017675bc8f8256291a3efa7e7e2d4.svg";
export { ForwardRef as ReactComponent };